"use client";

import React, {useEffect, useState} from "react";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import Load from "@/app/_components/Load/Load";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import {KitBehaviour} from "@/Fwk/Kit/KitBehaviour";
import Util from "@/Master/Util";

export interface LoadingDialogProps extends SDialogProps {
    onRefresh?: (s?:any) => void;
    showTimeout:number;
}

export const LoadingForceDialogFC: React.FC<LoadingDialogProps> = (props) => {
    const { fcKey, onClose,onRefresh,showTimeout } = props;
    const {closeDialog} = useDialogMethods(fcKey);
    const [isOpen, setIsOpen] = useState(false);

    const onForceDialog = () => {
        onClose && onClose();
        closeDialog();
    }

    const onUpdateTimeout = () => {
        if (Util.localTimeStamp <= showTimeout){
            onForceDialog();
        }
    }
    
    useEffect(() => {
        forceLoadingTime = Util.localTimeStamp;
        KitBehaviour._timer.SetTimer("onUpdateTimeout", onUpdateTimeout, -1, 1);
        return () => {
            KitBehaviour._timer.clearTask("onUpdateTimeout");
        };
    }, []);

    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Full"
            title=''
            isCloseHideAni={true}
        >
            <div
                className={`center`}
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Load/>
            </div>
        </SDialogFC>
    );
};

export let forceLoadingTime = 0;

export const showForceLoading = (call?: (open: boolean) => void) => {
    forceLoadingTime = 0;

    const showTime = Util.localTimeStamp;
    SDialogManagerFC.openDialog(LoadingForceDialogFC, {
        fcKey: SDialogManagerFC.getFCKey(LoadingForceDialogFC),
        showTimeout:showTime,
        onClose: (ok:boolean) => {
            call?.(ok);
        }
    })
};

export const hideForceLoading = () => {
    SDialogManagerFC.closeDialogFC(LoadingForceDialogFC)

}